/* eslint-disable max-len */
import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import FullScreenLoader from 'components/FullScreenLoader';
import styles from './UpgradeTiles.scss';// to import local scss fle
import { startTrial } from '../../common/services/saProfile.service';

class UpgradeTiles extends Component {
  static propTypes = {
    getTotalCounts: PropTypes.func.isRequired,
    profile: PropTypes.shape().isRequired,
    totalCounts: PropTypes.shape().isRequired,
    usedFor: PropTypes.string,
    showTrialButton: PropTypes.bool.isRequired,
    onTrial: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    usedFor: '',
  }
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      isLoading: false,
    };
  }

  componentWillMount() {
    if (this.props.profile.size > 0) {
      const saSports = this.props.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);

      const academic = this.props.profile.get('academic');

      const combinedHeight = this.props.profile.get('height');
      const heightIncm =
            (parseInt(combinedHeight.charAt(0)) * 12) + parseInt(combinedHeight.substr(2, 2)); // eslint-disable-line
      const payload = {
        stats: {
          student_parameters: {
            squats: parseInt(sport.get('squats'), 10),
            bench: parseInt(sport.get('bench'), 10),
            forty: parseFloat(sport.get('t40')),
            weight: parseInt(this.props.profile.get('weight'), 10),
            height: heightIncm,
          },
          role: 'QB',
          consider_squats_and_bench: 'yes',
        },
        gpa: parseFloat(academic.get('gpa'), 10),
        act: parseInt(academic.get('act'), 10),
      };
      this.props.getTotalCounts(payload);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile.size > 0 && !nextProps.totalCounts.size > 0) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);

      const academic = nextProps.profile.get('academic');

      const combinedHeight = nextProps.profile.get('height');
      const heightIncm =
              (parseInt(combinedHeight.charAt(0)) * 12) + parseInt(combinedHeight.substr(2, 2)); // eslint-disable-line
      const payload = {
        stats: {
          student_parameters: {
            squats: parseInt(sport.get('squats'), 10),
            bench: parseInt(sport.get('bench'), 10),
            forty: parseFloat(sport.get('t40')),
            weight: parseInt(this.props.profile.get('weight'), 10),
            height: heightIncm,
          },
          role: 'QB',
          consider_squats_and_bench: 'yes',
        },
        gpa: parseFloat(academic.get('gpa'), 10),
        act: parseInt(academic.get('act'), 10),
      };
      this.props.getTotalCounts(payload);
    }
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.isLoading,
    });
  }

  render() {
    let getTotalCountsCompleted = false;
    let saProfileID = '';
    const { showTrialButton } = this.props;
    if (this.props.profile !== undefined) {
      saProfileID = this.props.profile.get('id');
    }
    if (this.props.totalCounts.size > 0) {
      getTotalCountsCompleted = true;
    }
    const onPressTryForFree = () => {
      this.setLoader();
      const params = {
        id: saProfileID,
        trialType: 'free_trial_1',
      };
      startTrial(params)
      .then((res, err) => {
        if (!err) {
          this.setLoader();
          window.location.reload();
          // console.log(res);
        } else {
          this.setLoader();
          window.location.reload();
          // console.log(err);
        }
      });
    };
    const renderLoader = renderIf(!getTotalCountsCompleted || this.state.isLoading);
    // console.log('ontrialtile: ', this.props.onTrial);
    return (
      <div className={this.props.usedFor === 'profile_page' ? cn('col s12', styles.smallContainer) : cn('col s12', styles.container)}>
        {renderLoader(
          <FullScreenLoader />,
          )}
        {getTotalCountsCompleted ?
          <div className={cn('col s12')}>
            <div className={cn('col s12', styles.tilesContainer)}>
              <div >
                <img src="https://media.dev.myrecruitboard.com/Images/blur%403x.png" alt="blur" />
              </div>
            </div>
            <div className={styles.upgradeText}>
              <span>
                Congratulations your biometrics, position, and academics
                matched to {this.props.totalCounts.get('count')} colleges.
                Upgrade your account to start your recruiting
                process with these matches.<br /><br />
                {this.props.onTrial ? 'You are currently on a two day free trial. You can contact up to 10 colleges every 24 hours while your trial lasts. After that you will go back to 1 request every 24 hours. Please upgrade your account to continue the premium benefits after your trial ends.' :
                  'You are currently on a free account. You can contact 1 college every 24 hours. Please upgrade your account to contact up to 10 colleges a day.'}
                <span>
                  <Link to="/pricing">
                    <button style={{ marginTop: 20 }}>
                  UPGRADE NOW
             </button>
                  </Link>
                  {showTrialButton ? <button className={styles.tryButton} onClick={onPressTryForFree}>
                  TRY FOR FREE
             </button> : ''}
                </span>

              </span>
            </div>
          </div>
          : ''}
      </div>
    );
  }
}

export default UpgradeTiles;



// WEBPACK FOOTER //
// ./src/components/UpgradeTiles/UpgradeTiles.js